<template>
  <div class="bigScreenHome-container">
    <router-view v-if="reload" />
  </div>
</template>
  
  <script>

export default {
  name: "BigScreenHome",  
  provide() {
    return {
      refreshPage: this.refreshPage
    };
  },
  data() {
    return {
      reload: true
    };
  },
  created() {},
  methods: {
    //  刷新
    refreshPage() {
      this.reload = false;
      // 通过nextTick来实现刷新, 加定时器是为了防止刷新太快
      this.$nextTick(() => {
        setTimeout(() => {
          this.reload = true;
        }, 100);
      });
    }
  }
};
</script>
  
  <style lang="scss" scoped>
.bigScreenHome-container {
  width: 100%;
  height: 100vh;
  background: url("~@/assets/images/bigScreen/bg.png") 100% 100%;
  background-size: 100% 100%;
  color: #fff;
  overflow: hidden;
}
</style>
  